import { getFeedbackApiUrl } from '../utils/config';

class Api {
  constructor(options) {
    const {apiVersion, headers} = options || {};

    this.setHeaders(headers);
    this.setOptions({apiVersion: apiVersion || 'v1'});
  }

  setOptions(options) {
    const {apiVersion} = options || {};

    this.options = {apiVersion};
  }
  setHeaders(headers) {
    this.headers = headers;
  }
  get(url, options) {
    return this._request(url, {method: 'GET', ...options});
  }

  post(url, options) {
    const {body, ...otherOptions} = options || {};

    return this._request(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      body,
      ...otherOptions,
    });
  }

  _request(url, options) {
    const {apiVersion} = this.options;
    const {headers = {}, query} = options || {};
    const searchParams = new URLSearchParams(query).toString();
    
    // Получаем URL динамически
    const FEEDBACK_API_URL = getFeedbackApiUrl();
    
    if (!FEEDBACK_API_URL) {
      return Promise.reject(new Error('API URL not configured'));
    }
    
    const requestUrl = searchParams
      ? `${FEEDBACK_API_URL}/${url}?${searchParams}`
      : `${FEEDBACK_API_URL}/${url}`;

    return fetch(requestUrl, {
      ...options,
      headers: {...this.headers, ...headers},
    }).then((response) => {
      return response.json().then((result) => {
        if (!response.ok) {
          const error = new Error(result.message || 'Unknown error');
          error.responseData = result;
          error.status = response.status;
          throw error;
        }
        return result;
      });
    });
  }
}

export default new Api();
